import { api } from "./api";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function visitorId() {
  let id = localStorage.getItem("xd_vid");
  if (!id) {
    id = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("xd_vid", id);
  }
  return id;
}

export function captureUtm() {
  if (sessionStorage.getItem("xd_utm")) return;
  const p = new URLSearchParams(window.location.search);
  const u = {};
  UTM_KEYS.forEach((k) => { if (p.get(k)) u[k] = p.get(k); });
  if (!u.utm_source && document.referrer && !document.referrer.startsWith(window.location.origin)) {
    try { u.utm_source = new URL(document.referrer).hostname; } catch { /* ignore */ }
  }
  sessionStorage.setItem("xd_utm", JSON.stringify(u));
}

export const utm = () => JSON.parse(sessionStorage.getItem("xd_utm") || "{}");

export function track(type, extra = {}) {
  return api
    .post("/public/track", { visitor_id: visitorId(), type, utm: utm(), path: window.location.pathname, referrer: document.referrer || "", ...extra })
    .catch(() => {});
}

export function trackVisitOnce() {
  captureUtm();
  if (sessionStorage.getItem("xd_visit")) return;
  sessionStorage.setItem("xd_visit", "1");
  track("visit");
}
